import React from 'react';

import ExternalLink from 'components/ExternalLink';

import './styles.css';

const CustomerDetails = ({gocardlessCustomer}) => (
  <div className="CustomerDetails">
    <h5 className="header">Details</h5>
    <div className="content">
      <div className="box">
        <div className="title">GC Email</div>
        <div className="text">{gocardlessCustomer.email}</div>
      </div>
      <div className="box">
        <div className="title">GC Customer</div>
        {gocardlessCustomer.gocardlessId && (
          <ExternalLink
            className="link-text"
            href={gocardlessCustomer.link}
            targetBlank>
            {gocardlessCustomer.gocardlessId} →
          </ExternalLink>
        )}
        {!gocardlessCustomer.gocardlessId && '-'}
      </div>
      <div className="box">
        <div className="title">GC Mandate</div>
        {gocardlessCustomer.mandate.gocardlessId && (
          <ExternalLink
            className="link-text"
            href={gocardlessCustomer.mandate.link}
            targetBlank>
            {gocardlessCustomer.mandate.gocardlessId} →
          </ExternalLink>
        )}
        {!gocardlessCustomer.mandate.gocardlessId && '-'}
      </div>
    </div>
  </div>
);

export default CustomerDetails;
